module.exports = __webpack_public_path__ + "static/img/chuzhongwuli3.a3c62c78.jpg";